export const hospitals = [{
        value: "南通市肿瘤医院",
        label: "南通市肿瘤医院"
    },
    // {
    //     value: "南通大学附属医院",
    //     label: "南通大学附属医院"
    // },

    // {
    //     value: "南通市第一人民医院",
    //     label: "南通市第一人民医院"
    // },
    // {
    //     value: "南通市第二人民医院",
    //     label: "南通市第二人民医院"
    // },
    // {
    //     value: "南通市中医院",
    //     label: "南通市中医院"
    // },
    // {
    //     value: "南通市第三人民医院",
    //     label: "南通市第三人民医院"
    // },
    // {
    //     value: "南通市第四人民医院",
    //     label: "南通市第四人民医院"
    // },

    // {
    //     value: "启东市人民医院",
    //     label: "启东市人民医院"
    // },
    // {
    //     value: "海门市人民医院",
    //     label: "海门市人民医院"
    // },
    // {
    //     value: "如皋市人民医院",
    //     label: "如皋市人民医院"
    // },
    // {
    //     value: "海安市人民医院",
    //     label: "海安市人民医院"
    // },
    // {
    //     value: "如东县人民医院",
    //     label: "如东县人民医院"
    // },
    // {
    //     value: "通州市人民医院",
    //     label: "通州市人民医院"
    // },
]